<template>
<v-container fluid>
    <Datatable v-if="$_HASPERMISSION(NAME, getSession.user.id_tipo_utilizador)" :TableItems="TableItems" :TableHeaders="TableHeaders" :FormFields="FormFields" :TableActions="TableActions" :ModalNewText="ModalNewText" :ModalUpdateText="ModalUpdateText" :ModalDeleteText="ModalDeleteText" :DeleteDialogTitle="DeleteDialogTitle" :TableTitle="TableTitle" :Store="Store"/>
</v-container>
</template>
<script>
import {_MODELS} from '@/store/_MAIN'
const _NAME = 'GALARDAO_PEDIDO'
export default {
    components: {
        Datatable: () => import("@/components/Datatable")
    },
    computed: {
        getSession() {
            return this.$store.getters['session/getState']
        },
        TableItems() {
            return this.$store.getters[`${this.NAME}/getAll`].map((el)=>{
                el.instituicao = this.$store.getters['instituicao/getById'](el.id_instituicao);
                el.galardao = this.$store.getters['galardao/getById'](el.id_galardao);
                el.utilizador = this.$store.getters['utilizador/getById'](el.id_utilizador);
                el.dadivas = this.$store.getters['galardao/getDadivasById'](el.id_galardao);

                return el
            })
        }
    },
    data: () => ({
        Store: 'galardao_pedido',
        TableTitle: 'Galardões pedidos',
        ModalNewText: 'Novo pedido',
        ModalUpdateText: 'Alterar pedido',
        DeleteDialogTitle: 'Apagar pedido',
        ModalDeleteText: 'Pretende apagar este pedido?',
        TableActions: _MODELS[_NAME]._ACTIONS,
        FormFields: _MODELS[_NAME]._FIELDS,
        TableHeaders: _MODELS[_NAME]._HEADERS,
        NAME: _NAME.toLowerCase()
    })
}
</script>